"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const queryString = require("query-string");
exports.mergeQueryString = (url, queryParameters) => queryString.stringify(Object.assign(Object.assign({}, queryString.parse(url.search)), queryParameters));
